export default {
  TOKEN: 'TOKEN',
};
